import React, { useState, useEffect, useContext, useCallback } from 'react'
/* --------------------------------------------- */
import { useHistory } from 'react-router-dom'
import { GlobalContext } from './../../../context/global.context'
/* --------------------------------------------- */
import Button from '../../form/Button'

import { ImgContainer, InfoSubTitle, InfoTitle, InfoDesc, ButtonWrapper, InfoCtaDesc } from './styles'
import './_landing-page.scss'
import { useSelector } from 'react-redux'

/* --------------------------------------------- */
// LandingInfo component for showing top pageComponent
const LandingInfo = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const { landingIntro, themeSection: theme = {} } = props
  const { graphics: [imagesData = {}] = [], body = {} } = theme
  const { images: backgroundImages = [] } = imagesData
  const { background = {} } = body
  const [bgImage, updatebgImage] = useState(background?.primary || null)
  const { subTitle, title, description, ctaData, ctaDescription, ctaAction, ctaLink } = landingIntro
  const history = useHistory()
  const { dispatch } = useContext(GlobalContext)
  const { userManagementConfig = {} } = useSelector(store => store.userManagement)
  /* --------------------------------------------- */
  const { loginMethods = [] } = userManagementConfig
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  const resizeWindow = useCallback(() => {
    if (window.innerWidth < 650) {
      updatebgImage(backgroundImages[1]?.url)
    } else if (window.innerWidth > 650) {
      updatebgImage(backgroundImages[0]?.url)
    }
  }, [updatebgImage, backgroundImages])

  useEffect(() => {
    resizeWindow()
    window.addEventListener('resize', resizeWindow)
    return () => window.removeEventListener('resize', resizeWindow)
  }, [resizeWindow])

  const scroll = (id) => {
    const element = document.getElementById(id)
    const scrollPosition = element.offsetTop - 160 // to remove extra spacing frm specific div
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    })
  }

  const onclick = () => {
    if (ctaAction === 'sectionNavigation' && ctaLink && ctaLink.length) {
      const [link] = ctaLink
      const id = link.sys.id
      scroll(id)
    } else if (ctaAction === 'externalNavigation') {
      // Not implemented yet
      window.location.href = ''
    } else {
    // default behaviour
      dispatch({ type: 'RENDERED_LANDING', value: true })
      if ((loginMethods || []).indexOf('vdt') > -1) {
        dispatch({ type: 'SHOW_LOGIN_POPUP' })
        dispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onCloseClick: () => {
              dispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      } else {
        history.push('/SignUp')
      }
    }
  }

  return (
    <>
      <ImgContainer {...{ images: bgImage }} className='info-img-holder'>
        <div className='landing-detail'>
          {
            subTitle && (
              <InfoSubTitle {...{ theme }} className='infoSection__subtitle'>{subTitle}</InfoSubTitle>
            )
          }
          {
            title && (
              <InfoTitle {...{ theme }} className='infoSection__title'>{title}</InfoTitle>
            )
          }
          {
            description && (
              <InfoDesc {...{ theme }} className='infoSection__desc'>{description}</InfoDesc>
            )
          }
          {
            ctaData && (
              <ButtonWrapper {...{ theme: theme }}>
                <Button {...{ title: ctaData }} buttonClassname="font20" onClick={onclick} />
              </ButtonWrapper>
            )
          }
          {
            ctaDescription && (
              <InfoCtaDesc {...{ theme }} className='infoSection__ctadesc'>{ctaDescription}</InfoCtaDesc>
            )
          }
        </div>
      </ImgContainer>
    </>
  )
}

/* --------------------------------------------- */
LandingInfo.propTypes = {

}
/* --------------------------------------------- */
LandingInfo.defaultProps = {

}
/* --------------------------------------------- */
export default LandingInfo
